import React, { useEffect, useState } from 'react';
import { Button, ButtonGroup, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { connect } from 'react-redux';
import axios from 'axios';
import config from '../../config';
import { store } from '../../store';

// ...imports stay the same

function OrderTrackDetailModal({ onClose, orderId }) {
    const [responseData, setResponseData] = useState(null);
    const [collapseSections, setCollapseSections] = useState({
        'Partner Order Detail': true,
        'Visit Health Order Detail': false,
        'Transaction Detail': false,
    });

    const handleOrderStatusUpdate = async (status) => {
        try {
            const state = store.getState();
            const headers = state.user.token ? { authorization: state.user.token } : {};
            const { data } = await axios.post(
                `${config.pharmacyService}/partner/update-order-status`,
                { orderId: orderId, status: status},
                { headers }
            );
            alert(`IS UPDATED :${data?.update?.isUpdated}, MESSAGE: ${data?.update?.message}`);
        } catch (err) {
            onClose();
            const msg = err?.response?.data?.message || 'Failed to update order status.';
            alert(msg);
        }
    };

    useEffect(() => {
        const getOrderStatusDetails = async () => {
            try {
                const state = store.getState();
                const headers = state.user.token ? { authorization: state.user.token } : {};
                const { data } = await axios.get(
                    `${config.pharmacyService}/partner/fetch-order-detail?orderId=${orderId}`,
                    { headers }
                );
                setResponseData(data);
            } catch (err) {
                onClose();
                const msg = err?.response?.data?.message || 'Failed to fetch order status details.';
                alert(msg);
            }
        };

        if (orderId) getOrderStatusDetails();
        else alert("Please provide an Order ID.");
    }, [orderId]);

    const getSectionStyle = (title) => {
        switch (title) {
            case 'Partner Order Detail':
                return {
                    backgroundColor: '#e6f2ff',
                    borderColor: '#007acc',
                };
            case 'Visit Health Order Detail':
                return {
                    backgroundColor: '#f0f8e2',
                    borderColor: '#82b366',
                };
            case 'Transaction Detail':
                return {
                    backgroundColor: '#fbeeee',
                    borderColor: '#d9534f',
                };
            default:
                return {
                    backgroundColor: '#fff',
                    borderColor: '#3d3d3d',
                };
        }
    };

    const renderDetail = (label, value) => {
        const formattedLabel = label.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());

        const isURL = (val) => {
            try {
                new URL(val);
                return true;
            } catch (_) {
                return false;
            }
        };

        let displayValue;

        if (value === null || value === undefined || value === '') {
            displayValue = <span style={{ color: '#888' }}>N/A</span>;
        } else if (isURL(value)) {
            displayValue = (
                <a
                    href={value}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                        color: '#0f4a11',
                        fontWeight: 'bold',
                        textDecoration: 'underline',
                        wordBreak: 'break-all'
                    }}
                >
                    {value}
                </a>
            );
        } else {
            displayValue = <span style={{ color: '#0f4a11' }}>{value.toString()}</span>;
        }

        return (
            <div style={{ marginBottom: '8px' }}>
                <strong>{formattedLabel}:</strong> {displayValue}
            </div>
        );
    };

    const toggleSection = (title) => {
        setCollapseSections((prev) => ({ ...prev, [title]: !prev[title] }));
    };

    const renderSection = (title, obj) => {
        if (!obj || typeof obj !== 'object' || Object.keys(obj).length == 0) return null;

        const isCollapsed = collapseSections[title];
        const style = getSectionStyle(title);

        return (
            <div
                style={{
                    marginBottom: '30px',
                    padding: '20px',
                    border: `1px solid ${style.borderColor}`,
                    borderRadius: '10px',
                    backgroundColor: style.backgroundColor
                }}
            >
                <h5
                    style={{
                        marginBottom: isCollapsed ? '0px' : '20px',
                        color: style.borderColor,
                        fontWeight: 'bold',
                        cursor: 'pointer',
                        userSelect: 'none',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    }}
                    onClick={() => toggleSection(title)}
                >
                    {title}
                    <span style={{ fontSize: '16px', marginLeft: '10px' }}>
                        {isCollapsed ? '▼' : '▶'}
                    </span>
                </h5>

                {isCollapsed && (
                    <div style={{ marginTop: '15px' }}>
                        {Object.entries(obj).map(([key, value]) => {
                            if (Array.isArray(value)) {
                                return (
                                    <div key={key}>
                                        <strong>{key}:</strong>
                                        {value.map((item, index) => (
                                            <div
                                                key={index}
                                                style={{
                                                    marginTop: '10px',
                                                    padding: '15px',
                                                    border: '1px solid #ccc',
                                                    borderRadius: '8px',
                                                    backgroundColor: '#fff'
                                                }}
                                            >
                                                {Object.entries(item).map(([subKey, subValue]) => {
                                                    if (typeof subValue === 'object' && subValue !== null) {
                                                        return renderSection(subKey, subValue);
                                                    }
                                                    return renderDetail(subKey, subValue);
                                                })}
                                            </div>
                                        ))}
                                    </div>
                                );
                            } else if (typeof value === 'object' && value !== null) {
                                return renderSection(key, value);
                            } else {
                                return renderDetail(key, value);
                            }
                        })}
                    </div>
                )}
            </div>
        );
    };

    return (
        <Modal
            isOpen={true}
            toggle={onClose}
            style={{ maxWidth: '1400px', width: '100%' }}
        >
            <ModalHeader
                toggle={onClose}
                style={{
                    backgroundColor: '#eaf1f9',
                    color: '#2c3e50',
                    fontWeight: 'bold',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                    fontSize: '1.1rem',
                    paddingTop: '15px',
                    paddingBottom: '15px',
                    textAlign: 'center',
                    gap: '25px',
                    flexWrap: 'nowrap'
                }}
            >
                <span><strong>Partner Order Detail</strong></span>
                <span style={{ fontSize: '18px', fontWeight: 'normal' }}>  |  </span>
                <span><strong>Visit Health Order Detail</strong></span>
                <span style={{ fontSize: '18px', fontWeight: 'normal' }}>  |  </span>
                <span><strong>Transaction Detail</strong></span>
                <span style={{ fontSize: '18px', fontWeight: 'normal' }}>  |  </span>
                <span><strong>Order Id: {orderId} </strong></span>
                <span style={{ fontSize: '18px', fontWeight: 'normal' }}>  |  </span>
                <span><strong>Partner : {responseData?.order?.visitHealthOrderDetail.partner} </strong></span>
            </ModalHeader>

            <ModalBody style={{ backgroundColor: '#fff', padding: '30px' }}>
                <ButtonGroup style={{ display: 'flex', gap: '16px', padding: '16px' }}>
                    <Button
                        color="blue"
                        style={{
                            padding: '10px 20px',
                            borderRadius: '6px',
                            backgroundColor: '#007bff',
                            color: 'white',
                            border: 'none',
                            boxShadow: '0 2px 6px rgba(0, 0, 0, 0.15)',
                            cursor: 'pointer',
                        }}
                        onClick={() => handleOrderStatusUpdate('DELIVERED')}
                    >
                        Mark Delivered
                    </Button>
                    <Button
                        color="red"
                        style={{
                            padding: '10px 20px',
                            borderRadius: '6px',
                            backgroundColor: '#dc3545',
                            color: 'white',
                            border: 'none',
                            boxShadow: '0 2px 6px rgba(0, 0, 0, 0.15)',
                            cursor: 'pointer',
                        }}
                        onClick={() => handleOrderStatusUpdate('CANCELLED')}
                    >
                        Mark Cancelled
                    </Button>
                </ButtonGroup>
                {responseData ? (
                    <>
                        {responseData.order?.partnerEndOrderDetail && renderSection('Partner Order Detail', responseData.order?.partnerEndOrderDetail)}
                        {responseData.order?.visitHealthOrderDetail && renderSection('Visit Health Order Detail', responseData.order?.visitHealthOrderDetail)}
                        {responseData.order?.transactionDetail && renderSection('Transaction Detail', responseData.order?.transactionDetail)}
                    </>
                ) : (
                    <div style={{ color: '#888' }}>Loading...</div>
                )}
            </ModalBody>
        </Modal>
    );
}

const mapStateToProps = (state) => ({
    authToken: state.user.authToken,
    user: state.user,
});

export default connect(mapStateToProps)(OrderTrackDetailModal);
